import { render, staticRenderFns } from "./CollapsibleWidget.vue?vue&type=template&id=3eafe378"
import script from "./CollapsibleWidget.vue?vue&type=script&lang=js"
export * from "./CollapsibleWidget.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleWidget.vue?vue&type=style&index=0&id=3eafe378&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports